import SuccessContent from './SuccessContent';

export default SuccessContent;
